import { atom } from 'jotai';

export const favoriteOrgsAtom = atom<string[]>([]);
